import {LANG} from './Constants'

export class Utils
{
	static tr(key, def = undefined)
	{
		const lang = window['LANG'] || LANG;
		if(lang.hasOwnProperty(key))
		{
			return lang[key];
		}
		return def || '';
	}

	static randomColor()
	{
		let characters = ['a','b','c','d','e','f',0,1,2,3,4,5,6,7,8,9];
		let randomColorArray = [];
		let randomIndex;
		for (let i = 0; i < 6; i++)
		{
		    randomIndex = Math.floor(Math.random() * characters.length);
		    randomColorArray.push(characters[randomIndex]);
		}
		return '#' + randomColorArray.join('');
	}

	static easeOutBounce(x)
	{
		const n1 = 7.5625;
		const d1 = 2.75;

		if (x < 1 / d1)
		{
			return n1 * x * x;
		}
		else if (x < 2 / d1)
		{
			return n1 * (x -= 1.5 / d1) * x + 0.75;
		}
		else if (x < 2.5 / d1)
		{
		 	return n1 * (x -= 2.25 / d1) * x + 0.9375;
		}
	   	return n1 * (x -= 2.625 / d1) * x + 0.984375;
	}

	static arrayShuffle(arr)
	{
		let i, j, k;
		for(i = arr.length - 1; i > 0; i--)
		{
			j = Math.floor(Math.random() * (i + 1));
			k = arr[i];
			arr[i] = arr[j];
			arr[j] = k;
		}
	}
}
